<template>
 <div>
  <v-dialog v-model="hideShow" max-width="560" persistent scrollable content-class="student-bind-dialog">
   <v-card class="fc-dialog-card student-operation-dialog">
    <v-card-title class="fc-dialog-header">
     <span class="fc-dialog-symbol" aria-hidden="true"><v-icon color="#d9363e" size="22">mdi-cellphone-link</v-icon></span>
     <div><h2>绑定家长登录手机号</h2><p>设置与当前学员关联的家长登录账号</p></div>
     <v-spacer /><v-btn icon aria-label="关闭绑定家长手机号" @click="cancel"><v-icon size="21">mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="fc-dialog-body">
     <div class="student-operation-context"><span class="student-operation-avatar" aria-hidden="true"><v-icon size="22" color="#61748a">mdi-account-outline</v-icon></span><div><span>当前学员</span><strong>{{ studentName || '—' }}</strong></div></div>
     <v-form class="student-operation-form" @submit.prevent="submitBind">
      <v-text-field label="家长登录手机号" v-model="add.appUserMobile" type="tel" autocomplete="tel" color="#d9363e" dense outlined hide-details hint="请填写家长用于登录的手机号" />
      <p class="student-operation-hint">请核对家长手机号，确认无误后绑定。</p>
     </v-form>
    </v-card-text>
    <v-card-actions class="fc-dialog-actions"><v-spacer /><v-btn text @click="cancel">取消</v-btn><v-btn color="#d9363e" depressed class="fc-confirm" @click="submitBind">确认绑定</v-btn></v-card-actions>
   </v-card>
  </v-dialog>
 </div>
</template>

<script>
	export default {
		name:"bind-parent-mobile",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			studentId:{
				type:String,
				default:""
			},
			studentName:{
				type:String,
				default:""
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
			}
		},
		data(){
			return {
				add: {
					appUserMobile:""
				},
				
				hideShow:this.show
			}
		},
		mounted() {
			console.log("bind-parent-mobile mounted");
		},
		methods:{
			
			cancel(){
				this.$emit("cancel","");
			},
			submitBind() {
				if(!this.studentId){
					this.$noty.error('缺少参数');
					return
				}
				if (!this.add.appUserMobile) {
					this.$noty.error('请输入家长登录手机号');
					return
				}
			
				// api
				const that = this;
				let url = `/edu/student/app/user/bind`;
			
				// parameters
				const studentId = this.studentId;
				const mobile = this.add.appUserMobile;
				const postData = {
					studentId: studentId,
					appUserMobile: mobile,
				}
				console.log(postData);
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("绑定成功");
							that.$emit("success",{mobile:that.add.appUserMobile});
			
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
			
				});
			},
		}
	}
	
</script>

<style lang="scss" scoped>
@import "../assets/styles/student-operation-dialog";
</style>
